import React, { Component } from 'react'
import { Card, CardLink, CardBody, Form, Input, FormFeedback, FormGroup, Button, Alert } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import validaciones from '../../Auxiliares/validaciones'
import { toast } from 'react-toastify'

export default class modModulo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            noControl: this.props.noControl,
            nombre: this.props.nombre,
            ap_paterno: this.props.ap_paterno,
            ap_materno: this.props.ap_materno,
            semestre: this.props.semestre,
            carrera: this.props.carrera,
            errors: {},
            Errormsg: ''
        }
        this.guardar = this.guardar.bind(this)

    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                case 'noControl':
                    if (validaciones.validar_noControl(this.state.noControl)) {
                        value = validaciones.validar_noControl(this.state.noControl)
                        this.setState(prevState => ({ errors: { ...prevState.errors, noControl: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).noControl) });
                    }
                    break;

                case 'nombre':
                    if (validaciones.validar_nombre(this.state.nombre)) {
                        value = validaciones.validar_nombre(this.state.nombre)
                        this.setState(prevState => ({ errors: { ...prevState.errors, nombre: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).nombre) });
                    }
                    break;

                case 'ap_paterno':
                    if (validaciones.validar_ap_paterno(this.state.ap_paterno)) {
                        value = validaciones.validar_ap_paterno(this.state.ap_paterno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_paterno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_paterno) });
                    }
                    break;

                case 'ap_materno':
                    if (validaciones.validar_ap_materno(this.state.ap_materno)) {
                        value = validaciones.validar_ap_materno(this.state.ap_materno)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ap_materno: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ap_materno) });
                    }
                    break;
                
                    default:
                        break;
            }
        })
    }

    guardar() {
        const { id, noControl, nombre, ap_paterno, ap_materno, semestre, carrera } = this.state

        if (validaciones.sinErrores(this.state.errors)) {
            Fetch('/api/tmp/updateEstudiante', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id, noControl, nombre, ap_paterno, ap_materno, semestre, carrera })
            }).then(Response => {
                this.props.actualizar();
                this.props.cerrar();
            }).catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Error inesperado')
                        break;

                    case 601:
                        toast.error('Este usuario ya existe')
                        break;

                    case 604:
                        toast.error('Este usuario no pudo ser registrado')
                        break;
                    
                    default:
                        break;
                }
            })
        }
    }

    render() {

        return (
            <Card className="border-0">
                {this.state.Errormsg !== '' ? <Alert color="danger">{this.state.Errormsg}</Alert> : <div></div>}
                <CardBody>
                    <Form method="post" encType="multipart/form-data">
                        <FormGroup>
                            <Input type="text" className="w-100" onChange={this.setValue.bind(this, "noControl")} invalid={this.state.errors.noControl} placeholder="No. Control" name="noControl" maxLength="8" defaultValue={this.state.noControl} />
                            <FormFeedback>{this.state.errors.noControl}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Input type="text" className="w-100" onChange={this.setValue.bind(this, "nombre")} invalid={this.state.errors.nombre} placeholder="Nombre" name="Nombre" defaultValue={this.state.nombre} />
                            <FormFeedback>{this.state.errors.nombre}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Input type="text" className="w-100" onChange={this.setValue.bind(this, "ap_paterno")} invalid={this.state.errors.ap_paterno} placeholder="Apellido Paterno" name="ap_paterno" defaultValue={this.state.ap_paterno} />
                            <FormFeedback>{this.state.errors.ap_paterno}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Input type="text" className="w-100" onChange={this.setValue.bind(this, "ap_materno")} invalid={this.state.errors.ap_materno} placeholder="Apellido Materno" name="ap_materno" defaultValue={this.state.ap_materno} />
                            <FormFeedback>{this.state.errors.ap_materno}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Input type="select" name="carrera" onChange={this.setValue.bind(this, "carrera")} className="w-100" defaultValue={this.state.carrera} >
                                <option>Ing. en Sistemas Computacionales</option>
                                <option>Ing. Industrial</option>
                                <option>Ing. en Logistica</option>
                                <option>Ing. en Mecatronica</option>
                                <option>Ing. en Mecánica</option>
                                <option>Ing. en Gestion</option>
                                <option>Ing. en Energias Renovables</option>
                                <option>Ing. en Electronica</option>
                                <option>Ing. en Quimica</option>
                                <option>Ing. en Eléctrica</option>
                                <option>Lic. en Contabilidad</option>
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Input type="select" name="semestre" onChange={this.setValue.bind(this, "semestre")} defaultValue={this.state.semestre} >
                                <option>1</option>
                                <option>2</option>
                                <option>3</option>
                                <option>4</option>
                                <option>5</option>
                                <option>6</option>
                                <option>7</option>
                                <option>8</option>
                                <option>9</option>
                                <option>10</option>
                                <option>11</option>
                                <option>12</option>
                            </Input>
                        </FormGroup>
                        <div className="text-center">
                            <CardLink>
                                <Button color="info" onClick={this.guardar}>Guardar</Button>
                                <Button color="white" onClick={this.props.cerrar} >Cancelar</Button>
                            </CardLink>
                        </div>
                    </Form>
                </CardBody>
            </Card >
        )
    }
}
